"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoggingLevel = exports.setLoggingLevel = exports.getInitialGlobalLogLevel = void 0;
const getCookieOverride_1 = __importDefault(require("../getCookieOverride.js"));
const isInDev_1 = __importDefault(require("../isInDev.js"));
const isOnServer_1 = __importDefault(require("../isOnServer.js"));
const constants_1 = require("../constants.js");
/**
 * Get the initial value of globalLogLevel. This code is in a function so that we may unit test it.
 * @private
 */
const getInitialGlobalLogLevel = () => {
    const isDev = (0, isInDev_1.default)();
    let globalLogLevel;
    const override = (0, getCookieOverride_1.default)();
    if (override)
        return override;
    if ((0, isOnServer_1.default)()) {
        // On the server
        if (isDev) {
            globalLogLevel = constants_1.Level.debug; // everything will appear on the server console.
        }
        else {
            globalLogLevel = constants_1.Level.log; // everything *other than* logger.debug will appear in the logs (elk).
        }
    }
    else {
        globalLogLevel = isDev ? constants_1.Level.debug : constants_1.Level.none;
    }
    // if an invalid logging level was specified, hide all output.
    // istanbul ignore if: We can't really test this.
    if (!constants_1.LevelPriority[globalLogLevel]) {
        globalLogLevel = constants_1.Level.none;
    }
    return globalLogLevel;
};
exports.getInitialGlobalLogLevel = getInitialGlobalLogLevel;
let globalLogLevel = (0, exports.getInitialGlobalLogLevel)();
/**
 * This can be used to set logging programatically (Idea: Set logging level based on app-config).
 * @param level - The global logging level to be set. Once set, everything with a log level equal to
 *              or higher priority than the level supplied here will be logged. Everything else
 *              will be ignored.
 */
const setLoggingLevel = (level) => {
    globalLogLevel = level;
};
exports.setLoggingLevel = setLoggingLevel;
/**
 * The current log level.
 */
const getLoggingLevel = () => globalLogLevel;
exports.getLoggingLevel = getLoggingLevel;
